module.exports = __webpack_public_path__ + "./zone-illustration_8edb8b2a2b4893ba751bef986efacaeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/zone-illustration.png
// module id = 441
// module chunks = 0